import React from "react";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";

import RAGIndicator from "components/visuals/RAGIndicator";

import { selectors } from "modules/customer/insights/performance/budget/revenueVsBudgetOverTime";

const TrackingToBudget = () => {
    const trackingToBudget = useSelector(state => selectors.trackingToBudget(state));
    const { loading, error, id, label, status, value } = trackingToBudget;

    return (
        <Box data-cy={id}>
            <RAGIndicator loading={loading} error={error} label={label} status={status} value={value} />
        </Box>
    );
};

export default TrackingToBudget;
